module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAUCAIAAABj86gYAAAAyUlEQVRIx2Ng0E0iBrmn9/1HAveDcy8JmBCDGEYtGLWAcgvUfauIQSn1CwJi0tOLKnNKqwJj05/ktdw0DSYGMfwnDpy6cE4n2M7Ayi3cws4mwGbBpuVEaiTWgs7VUyWD5UM9/KP9giTCtdvWTqWyBfP2rBQOlnHzdbCyMecKVmtc3ktlCy6ePxdlYxFubxFqa+pvZnju7GliLSAyru5lN/z48eP3n99//v75/ft3QtVMIlMHA5GpDZgukd0FTLVEpu9RC0YtoNwCAH3woPBn45C4AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/do.png
// module id = 809
// module chunks = 0